import { Button, ButtonProps } from '@servicetitan/anvil2';
import { SetupDataStore, WorkflowStore } from '@servicetitan/financing-workflow-shared';
import { PlansEntryReason, PlansListTelemetryStore } from '@servicetitan/financing-utils-shared';
import { PropsWithChildren } from 'react';

export const CloseWithoutConfirmingButton = ({
    appearance,
    children,
    style,
}: PropsWithChildren<ButtonProps>) => {
    const { setWorkflowStage } = WorkflowStore.useStore();
    const { setupData, setSetupData } = SetupDataStore.useStore();
    const { setNextEntryReason } = PlansListTelemetryStore.useStore();

    const handleClick = () => {
        setNextEntryReason(PlansEntryReason.WorkflowReset);
        setWorkflowStage('reset');

        // Reset the isInSecondLook flag so provider selection works normally
        if (setupData?.isInSecondLook) {
            setSetupData({
                ...setupData,
                isInSecondLook: false,
            });
        }
    };

    return (
        <Button appearance={appearance ?? 'secondary'} style={style} onClick={handleClick}>
            {children}
        </Button>
    );
};
